/// <reference path="appbase.ts" />


namespace TerminalApp {
    let appId = "app_return";

    class ReturnRefundInfo {
        container: HTMLElement;

        refundInfo: SP.RefundInfo;

        updatedRefund: SP.UpdatedRefund;

        hasBundle:boolean;

        constructor(thisRefundInfo: SP.RefundInfo, hasBundle: boolean) {
            this.refundInfo = thisRefundInfo;

            this.hasBundle = hasBundle;

            this.updatedRefund = {
                confirmed: false,
                refundId: this.refundInfo.refundId,
                refundType: this.refundInfo.refundType,
                refundFee: this.refundInfo.returnFee,
                comment: "",
                lines: new Array()
            };

            this.initialize();

            // Change refund type
            this.container.querySelector(".returnRefund-select").addEventListener("change", (event) => {
                let thisTarget = event.target as HTMLSelectElement;
                this.updatedRefund.refundType = parseFloat(thisTarget.options[thisTarget.selectedIndex].value);
            });

            // Return fee
            this.container.querySelector(".returnRefund-input").addEventListener("input", (event) => {
                let thisTarget = event.target as HTMLInputElement;
                this.updatedRefund.refundFee = parseFloat(thisTarget.value);
            });

            // Comment
            this.container.querySelector(".return-comment").addEventListener("input", (event) => {
                let thisTarget = event.target as HTMLTextAreaElement;
                this.updatedRefund.comment = thisTarget.value;
            });

            if (this.hasBundle) {
                this.container.querySelector(".returnRefund-bundleAssistant-btn").addEventListener("click", () => {
                    App_Return.instance.openBundleAssistant();
                });
            }

            // Confirm Btn
            this.container.querySelector(".returnRefund-confirm-btn").addEventListener("click", async () => {
                SP.Sounds.Click.play();
                this.updatedRefund.confirmed = true;
                await this.confirmRefund();
            });

            // Cancel Btn
            this.container.querySelector(".returnRefund-cancel-btn").addEventListener("click", async () => {
                SP.Sounds.Click.play();
                await this.confirmRefund();
                App_Return.instance.reset(true);
            });
        }

        initialize() {
            this.container = document.createElement("div");
            this.container.classList.add("returnRefund-overall-container");

            this.container.innerHTML += `

                <div>
                    <h1 style="margin-top: 0 !important;">Refund type</h1>
                    <select class="return-select returnRefund-select">

                    </select>
                </div>

                <div style="margin-top: 20px;">
                    <h1 style="margin-top: 0 !important;">Return fee</h1>
                    <input class="returnRefund-input" type="number" step="any" placeholder="0.00" />
                </div>

                <div style="margin-top: 20px !important;">
                    <textarea class="return-comment" placeholder="${SP.Localize("word_comment")}"></textarea>
                </div>

                <div style="margin-top: 30px;">
                    <button class="returnRefund-bundleAssistant-btn grad-green">${SP.Localize("sentance_edit_bundle_lines")}</button>
                </div>

                <div style="margin-top: 30px;">
                    <button class="returnRefund-confirm-btn grad-green">${SP.Localize("word_confirm")}</button>
                </div>

                <div style="margin-top: 30px;">
                    <button class="returnRefund-cancel-btn">Later</button>
                </div>


                <div class="returnRefund-item-overall-container" style="margin-top: 30px;">
                    
                </div>
            `;

            if (!this.hasBundle) {
                this.container.querySelector(".returnRefund-bundleAssistant-btn").remove();
            }

            // Refund lines
            let totalOrderLinePriceIncVat = 0.00;
            for (let i = 0; i < this.refundInfo.lines.length; i++) {
                let refundLine = this.refundInfo.lines[i];

                if (totalOrderLinePriceIncVat == 0) {
                    totalOrderLinePriceIncVat = refundLine.refundPriceIncVat * refundLine.qty;
                }
                else {
                    totalOrderLinePriceIncVat += (refundLine.refundPriceIncVat * refundLine.qty);
                }


                this.container.querySelector(".returnRefund-item-overall-container").innerHTML += `
                    <div class="returnRefund-item-container" data-refundlineid="${refundLine.id}">
                        <div class="returnRefund-itemImage-container">
                            <img class="returnRefund-itemImage" src="${refundLine.orderLine.imageUrl}" />
                        </div>
                        <div class="returnRefund-itemInfo-container">

                            <span class="return-lineInfo-name">${refundLine.orderLine.description}</span>

                            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                                <span class="returnRefund-itemInfo-quantity"><b>Antal: ${refundLine.qty}</b></span>
                                <span class="returnRefund-itemInfo-price"><b>Pris: <span class="refundLinePrice">${refundLine.refundPriceIncVat * refundLine.qty}</span></b></span>
                            </div>
                        </div>
                    </div>
                `;
            }

            this.container.querySelector(".returnRefund-item-overall-container").innerHTML += `
                <div class="returnRefund-footer-container">
                    <span class="returnRefund-footer-total"><b>Total: <span class="returnRefund-total">${totalOrderLinePriceIncVat}</span></b></span>
                </div>
            `;

            if (this.refundInfo.refundType == SP.RefundType.Gift_card) {
                this.container.querySelector(".returnRefund-select").innerHTML = `
                    <option value="${SP.RefundType.Refund}">${SP.Localize("word_refund")}</option>
                    <option value="${SP.RefundType.Gift_card}" selected>${SP.Localize("word_refund")} (${SP.Localize("sentance_gift_card")})</option>
                `;
            }
            else {
                this.container.querySelector(".returnRefund-select").innerHTML = `
                    <option value="${SP.RefundType.Refund}" selected>${SP.Localize("word_refund")}</option>
                    <option value="${SP.RefundType.Gift_card}">${SP.Localize("word_refund")} (${SP.Localize("sentance_gift_card")})</option>
                `;
            }

            let returnFeeIncVat = 0.00;
            if (this.refundInfo.returnFeeIncVat != 0) {
                returnFeeIncVat = this.refundInfo.returnFeeIncVat;
            }

            let returnfeeInput = this.container.querySelector(".returnRefund-input") as HTMLInputElement;
            returnfeeInput.value = returnFeeIncVat.toString();
        }

        async confirmRefund() {
            try {
                StartLoading();

                var result = await SP.Data.Refund.updateRefund(this.updatedRefund);
                if (result != 200) {
                    SP.Sounds.Vibrate;
                    SP.Sounds.Error.play();
                    return;
                }

                SP.Sounds.Success.play();
                SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });

            } finally {
                StopLoading();
            }
        }
    }


    class ReturnShipmentInfo {
        container: HTMLElement;
        data: SP.ShipmentLineInfo;

        updatedShipmentLine: SP.UpdatedShipmentLine;

        constructor(shipmentId: string, line: SP.ShipmentLineInfo, qty: number) {
            this.data = line;

            this.updatedShipmentLine = {
                shipmentId: shipmentId,
                shipmentLineId: line.id,
                orderLineId: line.orderLine.id,
                quantity: qty,
                note: line.returnInfo.note,
                warehouseActionId: line.returnInfo.warehouseReturnActionId,
                warehouseReasonId: line.returnInfo.warehouseReturnReasonId
            };

            this.initialize(line, qty);

            // Plus 1 to input field
            this.container.querySelector(".return-lineEdit-add-btn").addEventListener("click", (event) => {
                let thisTarget = event.currentTarget as HTMLElement;
                SP.Sounds.Click.play();

                let input = thisTarget.closest(".return-lineEdit-middle-container").querySelector(".return-lineEdit-input") as HTMLInputElement;

                this.addOrSubtractQuantityInput(true, input);
            });


            // Subtract 1 from input field
            this.container.querySelector(".return-lineEdit-sub-btn").addEventListener("click", (event) => {
                let thisTarget = event.currentTarget as HTMLElement;
                SP.Sounds.Click.play();

                let input = thisTarget.closest(".return-lineEdit-middle-container").querySelector(".return-lineEdit-input") as HTMLInputElement;

                this.addOrSubtractQuantityInput(false, input);
            });


            // Open settings/details
            this.container.querySelector(".return-lineEdit-edit-btn").addEventListener("click", async () => {
                SP.Sounds.Click.play();

                App_Return.instance.editShipmentInfoAssistant.open((warehouseReasonId, warehouseActionId, note) => {

                    if (warehouseActionId === "") {
                        warehouseActionId = "00000000-0000-0000-0000-000000000000"
                    }

                    if (warehouseReasonId === "") {
                        warehouseReasonId = "00000000-0000-0000-0000-000000000000";
                    }

                    this.updatedShipmentLine.warehouseReasonId = warehouseReasonId;
                    this.updatedShipmentLine.warehouseActionId = warehouseActionId;
                    this.updatedShipmentLine.note = note;


                    let warehouseReasonName = "None"; 
                    let warehouseReasons = App_Return.instance.warehouseReasons;
                    let reasonIndex = warehouseReasons.findIndex((x) => x.id === warehouseReasonId);
                    if (reasonIndex > -1) {
                        warehouseReasonName = warehouseReasons[reasonIndex].name;
                    }

                    this.container.querySelector(".return-lineInfo-reason-text").innerHTML = warehouseReasonName;

                }, this.updatedShipmentLine);
            });

            // Edit input quantity
            this.container.querySelector(".return-lineEdit-input").addEventListener("input", (event) => {
                let thisTarget = event.currentTarget as HTMLInputElement;
                SP.Sounds.Click.play();

                let parsedQuantity = parseFloat(thisTarget.value);

                if (thisTarget.value.length == 0 || thisTarget.value.startsWith("0") || thisTarget.value.startsWith("-")) {
                    thisTarget.value = "0";
                }

                parsedQuantity = parseFloat(thisTarget.value);
                if (isNaN(parsedQuantity)) {
                    console.log("Not a number");
                    thisTarget.value = "0";
                    return;
                }

                this.updatedShipmentLine.quantity = parsedQuantity;

                App_Return.instance.refreshReturnCount();
                this.updateQuantityResult(parsedQuantity, line.qty);
            });
        }

        initialize(line: SP.ShipmentLineInfo, qty: number) {
            this.container = document.createElement("div");
            this.container.classList.add("return-line-container");
            this.container.setAttribute("data-itembarcodes", line.orderLine.itemInfo.barcodes.toString())

            this.container.innerHTML += `
                <div class="return-lineInfo-overall-container">
                    <div class="return-lineInfo-container">
                        <span class="return-lineInfo-sku">${line.orderLine.itemInfo.sku}</span>
                        <span class="return-lineInfo-name">${line.orderLine.description}</span>
                        <span class="return-lineInfo-barcode">${line.orderLine.itemInfo.barcodes}</span>

                        <span class="return-lineInfo-reason">${SP.Localize("word_reason")}: <span class="return-lineInfo-reason-text"></span></span>

                        <div class="return-lineInfo-comment-container">
                            <span class="return-lineInfo-comment-headline" style="display: block;">${SP.Localize("word_comment")}:</span>
                            <span class="return-lineInfo-comment">${line.returnInfo.comment}</span>
                        </div>

                    </div>
                    <div class="return-lineInfo-image-container">
                        <img class="return-lineInfo-image" src="${line.orderLine.imageUrl}">
                    </div>
                </div>

                <div class="return-lineEdit-container">

                    <div class="return-lineEdit-edit-btn">
                        <i class="fa-solid fa-gear"></i>
                    </div>

                    <div class="return-lineEdit-middle-container">
                        <div class="return-lineEdit-sub-btn">
                            <i class="fas fa-minus"></i>
                        </div>

                        <div class="return-lineEdit-input-container">
                            <div style="width: 50%;">
                                <input class="return-lineEdit-input" type="number" step="any" min="0" value="${line.returnInfo.returnedQty}" />
                            </div>

                            <div style="width: 50%;">
                                <span class="return-lineEdit-expected">/ ${line.qty}</span>
                            </div>

                        </div>

                        <div class="return-lineEdit-add-btn">
                            <i class="fas fa-plus"></i>
                        </div>
                    </div>

                    <div class="return-lineEdit-result">
                        OK
                    </div>
                </div>
            `;

            if (line.returnInfo.returnedQty != 0) {
                this.updatedShipmentLine.quantity = line.returnInfo.returnedQty;
            }

            let warehouseReasonName = "None";
            let warehouseReasons = App_Return.instance.warehouseReasons;

            console.log("reasons", warehouseReasons, line.returnInfo.warehouseReturnReasonId);

            let reasonIndex = warehouseReasons.findIndex((x) => x.id === line.returnInfo.warehouseReturnReasonId);
            if (reasonIndex > -1) {
                const reason = warehouseReasons[reasonIndex];
                warehouseReasonName = reason.name;

                if (reason.complaint) {
                    this.container.classList.add("bg-warning");
                }

            }


            this.container.querySelector(".return-lineInfo-reason-text").innerHTML = warehouseReasonName;

            this.updateQuantityResult(this.updatedShipmentLine.quantity, line.qty);
        }

        addOrSubtractQuantityInput(add: boolean, input: HTMLInputElement, amt: number = 1) {
            let quantity = parseInt(input.value);
            if (isNaN(quantity)) {
                SP.Sounds.Vibrate;
                SP.Sounds.Error.play();
                SP.alertX("Quantity is not a number");
                return;
            }

            let expectedQty = parseFloat(input.closest(".return-lineEdit-middle-container").querySelector(".return-lineEdit-expected").innerHTML.replace("/ ", ""));
            if (isNaN(expectedQty)) {
                SP.Sounds.Vibrate;
                SP.Sounds.Error.play();
                SP.alertX("Expected quantity is not a number");
                return;
            }

            if (add) {
                quantity += amt;
            }
            else {
                if (quantity == 0) {
                    return;
                }

                quantity -= amt;
                if (quantity < 0) quantity = 0;
            }

            input.value = quantity.toString();

            this.updatedShipmentLine.quantity = quantity;

            App_Return.instance.refreshReturnCount();

            this.updateQuantityResult(quantity, expectedQty);
        }

        addQuantity(qty: number = 1) {
            let input = this.container.querySelector(".return-lineEdit-input") as HTMLInputElement;
            this.addOrSubtractQuantityInput(true, input, qty);
        }

        updateQuantityResult(quantity: number, expectedQty: number) {
            let result = quantity - expectedQty;

            let resultContainer = this.container.querySelector(".return-lineEdit-result") as HTMLElement;

            if (result == 0) {
                resultContainer.innerHTML = "OK";
                resultContainer.style.backgroundColor = "#e0e0e0";
            }
            else if (result < 0) {
                resultContainer.innerHTML = result.toString();
                resultContainer.style.backgroundColor = "rgb(239, 198, 198)";
            }
            else {
                resultContainer.innerHTML = "+" + result.toString();
                resultContainer.style.backgroundColor = "rgb(236, 241, 171)";
            }
        }
    }


    class ReturnOrderInfo {
        container: HTMLElement;
        shipmentLineArray = new Array();
        order: SP.ReturnOrderInfo;
        customer: SP.CustomerInfo;
        constructor(order: SP.ReturnOrderInfo, customer: SP.CustomerInfo) {
            this.order = order;
            this.customer = customer;
            this.shipmentLineArray = new Array();
            this.initialize();

            //Show shipment details button
            this.container.querySelectorAll(".returnsShowShipmentDetails").forEach((element) => {
                element.addEventListener("click", (event) => {
                    let thisTarget = event.target as HTMLElement;
                    SP.Sounds.Click.play();

                    this.showShipmentDetails(thisTarget);
                });
            });

            //Choose shipment button
            this.container.querySelectorAll(".returnChooseShipment").forEach((element) => {
                element.addEventListener("click", (event) => {
                    let thisTarget = event.target as HTMLElement;
                    SP.Sounds.Click.play();

                    App_Return.instance.currentShipmentId = thisTarget.getAttribute("data-shipmentid");
                    App_Return.instance.OpenStep2(thisTarget.getAttribute("data-shipmentid"), null);
                });
            });

            //Create shipment button
            let createBtn = this.container.querySelector(".returnsCreateShipmentBtn");
            if (createBtn) {
                createBtn.addEventListener("click", async (event) => {
                    let thisTarget = event.target as HTMLElement;
                    SP.Sounds.Click.play();

                    this.createShipment(thisTarget.getAttribute("data-orderid"));
                });
            }
        }


        initialize() {
            this.container = document.createElement("div");

            let orderHtml = document.createElement("div");
            orderHtml.classList.add("returns-search-result-container");

            orderHtml.innerHTML = `
                <div class="returns-search-result-order-holder">
                    <div style="display: flex; align-items: center; border-bottom: 1px solid #f4f4f4; padding: 10px 10px; background-color: #f4f4f4;">
                        <i class="fa-sharp fa-solid fa-basket-shopping" style="font-size: 23px !important; margin-right: 8px;"></i>
                        <p class="marginPaddingNone" style="font-size: 21px;"><b> ${this.order.orderNo} - ${App_Return.instance.currentCustomer.customerName}</b></p>
                    </div>

                    <div class="returns-search-result-order-holder-info">
                        <p class="marginPaddingNone">${SP.Localize("sentance_reference_no")}:</p>
                        <p class="marginPaddingNone"><b>${this.order.referenceNo}</b></p>

                        <p class="marginPaddingNone" style="margin-top: 10px !important;">${SP.Localize("word_name")}:</p>
                        <p class="marginPaddingNone"><b>${this.order.recipient.name}</b></p>
                    </div>
                </div>

                <div class="returns-search-result-shipment-holder-overall-container"></div>
            `;

            let newDivShipmentHolder = orderHtml.querySelector(".returns-search-result-shipment-holder-overall-container");
            if (this.order.shipments.length == 0) {

                this.container.innerHTML = `
                    <div class="return-edit-returnInfo-overall-container" style="margin-bottom: 30px !important;">

                        <div class="return-edit-returnInfo-container returnAction" style="margin-top: 20px !important;">
                            <h1 style="margin-top: 0 !important;">Action</h1>
                            <select class="return-select return-select-action">
                                <option value="" disabled>${SP.Localize("sentance_select_action")}</option>
                            </select>
                        </div>

                        <div class="return-edit-returnInfo-container returnReason">
                            <h1 style="margin-top: 0 !important;">Reason</h1>
                            <select class="return-select return-select-reason">
                                <option value="" disabled>${SP.Localize("sentance_select_reason")}</option>
                            </select>
                        </div>

                    </div>
                `;

                newDivShipmentHolder.innerHTML = `
                    <div class="returns-search-result-shipment-holder">
                        <p style="font-size: 20px; text-align: center; margin: 0 !important; padding: 15px 0 !important;">${SP.Localize("sentance_no_return_shipments_was_found")}</p>

                        <div style="margin-bottom: 8px;">
                            <a class="returnsCreateShipmentBtn" data-orderid="${this.order.orderId}">${SP.Localize("word_create")}</a>
                        </div>
                    </div>
                `;

                this.populateAction();
                this.populateReason();
            }
            else {
                for (var i = 0; i < this.order.shipments.length; i++) {
                    let shipment = this.order.shipments[i];

                    if (!this.shipmentLineArray.includes(shipment)) {
                        this.shipmentLineArray.push(shipment);
                    }

                    let shipmentState = SP.Localize("word_pending");
                    if (shipment.shipmentState == SP.ShipmentState.ReturnReceived) {
                        shipmentState = SP.Localize("word_received")
                    }

                    newDivShipmentHolder.innerHTML += `
                        <div class="returns-search-result-shipment-holder-container">
                            <div class="returns-search-result-shipment-holder">

                                <div class="returns-search-result-shipment-info-holder">

                                    <div class="returns-search-shipment-icon-container">
                                        <i class="fa-sharp fa-solid fa-box-open-full returns-search-shipment-icon" style="font-size: 22px !important;"></i>
                                    </div>

                                    <div class="returns-search-result-shipment-details-holder">
                                        <div>
                                            <p class="marginPaddingNone returns-search-result-shipment-details-text">${SP.Localize("sentance_shipment_no")}: <b>${shipment.shipmentNo}</b></p>
                                            <p class="marginPaddingNone returns-search-result-shipment-details-text">${SP.Localize("word_state")}: <b>${shipmentState}</b></p>
                                        </div>

                                        <div class="returns-search-result-shipment-actions-holder">
                                            <a class="returns-search-result-shipment-action returnsShowShipmentDetails" data-shipmentid="${shipment.shipmentId}">
                                                <i class="fas fa-eye returns-search-result-shipment-action-icon"></i>
                                            </a>

                                            <a class="returns-search-result-shipment-action-btn returnChooseShipment" data-shipmentid="${shipment.shipmentId}">
                                                ${SP.Localize("word_choose")}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="returns-search-result-shipment-items-overall-container"></div>

                            </div>
                         </div>
                    `;
                }

            }

            this.container.appendChild(orderHtml);
        }


        async populateAction() {
            try {
                let actions = App_Return.instance.warehouseActions;
                if (actions == null) {
                    return;
                }

                let actionSelect = this.container.querySelector(".return-select-action");
                for (let i = 0; i < actions.length; i++) {
                    if (actions[i].returnActionType != SP.ReturnActionType.Exchange) {
                        let isSelected = "";

                        if (actions[i].id == this.customer.defaultReturnActionId) {
                            isSelected = "selected";
                        }

                        actionSelect.innerHTML += `
                        <option value="${actions[i].id}" ${isSelected}>${actions[i].name}</option>
                    `;   
                    }
                }
            } catch {
                SP.alertX("PopulateAction Error!");
            }
        }


        async populateReason() {
            try {
                var reasons = App_Return.instance.warehouseReasons;
                if (reasons == null) {
                    return;
                }

                let reasonSelect = this.container.querySelector(".return-select-reason");
                for (var i = 0; i < reasons.length; i++) {
                    let isSelected = "";

                    if (reasons[i].id == this.customer.defaultReturnReasonId) {
                        isSelected = "selected";
                    }
    
                    reasonSelect.innerHTML += `
                        <option value="${reasons[i].id}" ${isSelected}>${reasons[i].name}</option>
                    `;
                }
            } catch {
                SP.alertX("PopuilateReason Error!");
            }
        }


        // Create Shipment
        async createShipment(orderId: string) {
            StartLoading();

            let actionSelect = this.container.querySelector(".return-select-action") as HTMLSelectElement;
            let selectedActionId = actionSelect.options[actionSelect.selectedIndex].value;
            if (selectedActionId == null || selectedActionId == "" || selectedActionId == "00000000-0000-0000-0000-000000000000") {
                SP.alertX(SP.Localize("sentance_no_return_action_selected"));
                StopLoading();
                return;
            }


            let reasonSelect = this.container.querySelector(".return-select-reason") as HTMLSelectElement;
            let selectedReasonId = reasonSelect.options[reasonSelect.selectedIndex].value;
            if (selectedReasonId == null || selectedReasonId == "" || selectedReasonId == "00000000-0000-0000-0000-000000000000") {
                SP.alertX(SP.Localize("sentance_no_return_reason_selected"));
                StopLoading();
                return;
            }

            try {
                let data = await SP.Data.ReturnShipment.createReturnShipment(orderId, selectedActionId, selectedReasonId);
                if (data == null) {
                    SP.Sounds.Vibrate;
                    SP.Sounds.Error.play();
                    SP.alertX("Error");
                    return;
                }

                App_Return.instance.closeAllPages();
                App_Return.instance.OpenStep2(data.shipmentId, null);
            }
            finally {
                StopLoading();
            }

        }


        // Show shipment details
        showShipmentDetails(element: HTMLElement) {
            let foundElement = this.shipmentLineArray.filter((thisElement) => {
                return thisElement.shipmentId === element.getAttribute("data-shipmentid");
            });

            let outputElement = element.closest(".returns-search-result-shipment-holder").querySelector(".returns-search-result-shipment-items-overall-container");

            if (outputElement.hasChildNodes()) {
                outputElement.innerHTML = "";
                return;
            }

            for (var i = 0; i < foundElement[0].lines.length; i++) {
                let line = foundElement[0].lines[i];

                let newElement = document.createElement("div");

                newElement.classList.add("returns-search-result-shipment-item-holder");

                newElement.innerHTML = `
                    <div class="returns-search-result-shipment-item-holder-border-container">
                        <div class="returns-search-result-shipment-item-image-container">
                            <img class="returns-search-result-shipment-item-image" src="${line.orderLine.imageUrl}" />
                        </div>

                        <div class="returns-search-result-shipment-item-details-container">
                            <div>
                                <p class="marginPaddingNone"><b>${line.orderLine.itemInfo.description}</b></p>
                                <p class="marginPaddingNone">Sku: ${line.orderLine.itemInfo.sku}</p>
                            </div>

                            <p class="marginPaddingNone">${line.returnInfo.returnedQty} / ${line.qty}</p>
                        </div>
                    </div>
                `;

                outputElement.appendChild(newElement);
            }
        }
    }


    class ReturnOrderCustomerInfo {

        container: HTMLElement;
        order: SP.OrderInfo

        constructor(order: SP.OrderInfo) {
            this.order = order;

            this.initialize();
        }

        initialize() {
            this.container = document.createElement("div");
            this.container.classList.add("returns-search-result-container");

            let name = this.order.recipient.name;
            if (name == null || name == "") {
                name = this.order.recipient.attention;
            }

            this.container.innerHTML = `
                <div class="returns-search-result-order-holder">
                    <div style="display: flex; align-items: center; border-bottom: 1px solid #f4f4f4; padding: 10px 10px; background-color: #f4f4f4;">
                        <i class="fa-sharp fa-solid fa-basket-shopping" style="font-size: 23px !important; margin-right: 8px;"></i>
                        <p class="marginPaddingNone" style="font-size: 21px;"><b>${this.order.orderNo} - ${App_Return.instance.currentCustomer.customerName}</b></p>
                    </div>

                    <div class="returns-search-result-order-holder-info">
                        <p class="marginPaddingNone">${SP.Localize("word_name")}:</p>
                        <p class="marginPaddingNone"><b>${name}</b></p>
                    </div>
                </div>
            `;

        }
    }

    export class App_Return extends AppBase {
        static instance: App_Return;
        bound = false;

        button_search_order = document.getElementById("return-search-order");
        return_finish_button_placement = document.getElementById("return_finish_button_placement") as HTMLElement;
        return_finish_button = document.getElementById("return_finish_button") as HTMLElement;
        scanLogo_container = document.getElementById("return-scan-logo") as HTMLElement;

        step1_container = document.getElementById("return-step1-container") as HTMLElement;
        step2_container = document.getElementById("return-step2-container") as HTMLElement;
        step3_container = document.getElementById("return-step3-container") as HTMLElement;

        return_status = document.getElementById("return_status") as HTMLElement;

        return_picked_count = document.getElementById("return_picked_count") as HTMLElement;
        return_pick_count = document.getElementById("return_pick_count") as HTMLElement;

        searchAssistant: OrderShipmentSearchAssistant;
        editShipmentInfoAssistant: EditShipmentInfoAssistant;
        refundBundleAssistant: RefundBundleAssistant;

        currentStep = 1

        currentOrder: SP.ReturnOrderInfo;
        currentShipmentId: string;
        currentCustomer: SP.CustomerInfo;
        currentRefund: SP.RefundInfo;
        currentRefundBundleBalanceLines: SP.RefundBundleBalanceLine[];

        warehouseReasons: SP.WarehouseReasonInfo[];
        warehouseActions: SP.WarehouseActionInfo[];

        currentReturnRefundInfo: ReturnRefundInfo;

        lines: { [key: string]: ReturnShipmentInfo } = {};

        constructor() {
            super(appId);
            App_Return.instance = this;

            this.searchAssistant = new OrderShipmentSearchAssistant();
            this.editShipmentInfoAssistant = new EditShipmentInfoAssistant();
            this.refundBundleAssistant = new RefundBundleAssistant();
            container.appendChild(this.searchAssistant.container);
            container.appendChild(this.editShipmentInfoAssistant.container);
            container.appendChild(this.refundBundleAssistant.container);

            this.button_search_order.addEventListener("click", () => {
                SP.Sounds.Click.play();

                this.searchAssistant.open((order) => {

                    if (order.shipments.length == 0 || order.shipments.length > 1) {
                        this.OpenStep1(order);
                    }
                    else {
                        this.OpenStep2(order.shipments[0].shipmentId, order.shipments[0]);
                    }
                    
                });
            });

            // Finish with placement
            this.return_finish_button_placement.addEventListener("click", async () => {

                if (!this.checkIdLinesIsValid()) {
                    if (await SP.confirmX(SP.Localize("description_no_quantity_cancel_return_shipment"))) {
                        try {
                            StartLoading();

                            let result = await SP.Data.ReturnShipment.cancelReturnShipment(this.currentShipmentId);

                            if (result != 200) {
                                SP.alertX(result);
                            }

                            this.reset(true);
                            SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });

                        } finally {
                            StopLoading();
                        }
                    }

                    return;
                }

                placementPickerAssistant.open(this.currentOrder.customerId, SP.Localize("sentance_scan_select_stock_placement"), async (placement) => {
                    let [status, msg] = await this.finishReturn(placement.id)
                    if (!status) {
                        SP.alertX(msg.toString());
                    }
                });

                return;
            });
            
            // Finish whithout placement
            this.return_finish_button.addEventListener("click", async () => {

                if (!this.checkIdLinesIsValid()) {
                    if (await SP.confirmX(SP.Localize("description_no_quantity_cancel_return_shipment"))) {
                        try {
                            StartLoading();

                            let result = await SP.Data.ReturnShipment.cancelReturnShipment(this.currentShipmentId);

                            if (result != 200) {
                                SP.alertX(result);
                            }

                            this.reset(true);
                            SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });

                        } finally {
                            StopLoading();
                        }
                    }

                    return;
                }

                if (await SP.confirmX(SP.Localize("sentance_are_you_sure_you_want_to_finish_without_product_stock_placement"))) {
                    let [status, msg] = await this.finishReturn(0);
                    if (!status) {
                        SP.alertX(msg.toString());
                    }
                }

                return;
            });
        }


        checkIdLinesIsValid() {
            let hasQuantity = false;
            for (let key in this.lines) {
                let l = this.lines[key];

                if (l.updatedShipmentLine.quantity > 0) {
                    hasQuantity = true;
                }
            }

            if (!hasQuantity) {
                SP.Sounds.Error.play();
                SP.Sounds.Vibrate;

                return false;
            }

            return true;
        }

        async scanTote(toteId: string) {
            var info = await SP.Data.Tote.getToteInfo(toteId, false);
            if (info.totePlacementId && info.totePlacementId > 0) {
                let [status, msg] = await this.finishReturn(info.totePlacementId);
                if (!status) {
                    SP.alertX(msg + " try again or contact support");
                }
            }
        }

        async finishReturn(placementId: number) {
            let result = true;
            let message = "";
            let hasFinishedShipment = false;

            if (this.currentStep != 2) {
                result = false;
                message = "Current step is not step 2";
                return [result, message];
            }

            var returnLines: any[] = [];
            for (let key in this.lines) {
                let l = this.lines[key];
                returnLines.push(l.updatedShipmentLine);
            }

            var postdata: any = {
                orderId: this.currentOrder.orderId,
                shipmentId: this.currentShipmentId,
                returnLines: returnLines,
                placementId: placementId,
            };

            StartLoading();

            try {

                // Finish return shipment and check status.
                let finishReturnShipmentResult = await SP.Data.ReturnShipment.finishReturnShipment(postdata);
                if (finishReturnShipmentResult.status != 200) {
                    SP.Sounds.Error.play();
                    SP.Sounds.Vibrate;
                    result = false;
                    message = finishReturnShipmentResult.msg;
                    return [result, message];
                }

                hasFinishedShipment = true;

                // Create and check if refund status.
                let createRefundResult = await SP.Data.Refund.createRefund(this.currentShipmentId);
                console.log(createRefundResult.status);
                if (createRefundResult.status == 5314) {
                    SP.Sounds.Success.play();
                    this.reset(true);
                    return [null, null];
                }

                if (createRefundResult.status != 200) {
                    SP.Sounds.Error.play();
                    SP.Sounds.Vibrate;
                    result = false;
                    message = createRefundResult.msg;
                    return [result, message];
                }

                SP.Sounds.Success.play();

                if (createRefundResult.data &&
                    App_Settings.userRights.refund &&
                    (this.currentCustomer.defaultReturnMethod === SP.ReturnMethod.ReceiveAndRefundAndConfirm || this.currentCustomer.defaultReturnMethod === SP.ReturnMethod.ReceiveAndRefundAndConfirmExclGiftcard)
                ) {
                    this.OpenStep3(createRefundResult.data);
                    return [result, ""];
                }

                this.reset(true);
            }
            catch (error) {
                if (hasFinishedShipment) {
                    SP.Sounds.Success.play();
                    message = "Refund failed, create manually";
                    this.reset(true);
                    return [true, message];
                }


                SP.Sounds.Error.play();
                SP.Sounds.Vibrate;
                result = false;
                message = "InternalServerError";
                return [result, message];
            }
            finally {
                StopLoading();
                return [result, message];
            }
        }

        async scan(barcode: string) {
            if (this.currentStep == 1) {
                this.currentOrder = null;

                this.searchReturnShipments(barcode);
            }
            else if (this.currentStep == 2) {
                let itemFound = false;
                for (let key in this.lines) {
                    let thisLine = this.lines[key];
                    let qty = GetBarcodeQty(thisLine.data.orderLine.itemInfo.allBarcodes, barcode);
                    if (qty !== null) {
                        itemFound = true;
                        thisLine.addQuantity(qty);
                        return;
                    }
                }

                if (!itemFound) {
                    for (let i = 0; i < this.currentOrder.orderLines.length; i++) {
                        let thisOrderLine = this.currentOrder.orderLines[i];

                        let barcodes = thisOrderLine.itemInfo.barcodes;
                        for (let j = 0; j < barcodes.length; j++) {
                            if (barcodes[j] === barcode) {

                                let shipmentLine: SP.ShipmentLineInfo = {
                                    id: "00000000-0000-0000-0000-000000000000",
                                    orderLine: thisOrderLine,
                                    qty: 0,
                                    returnInfo: {
                                        comment: "",
                                        note: "",
                                        returnedQty: 1,
                                        overrideAction: null,
                                        warehouseReturnActionId: "00000000-0000-0000-0000-000000000000",
                                        warehouseReturnReasonId: "00000000-0000-0000-0000-000000000000",
                                    },
                                    data: null,
                                };

                                try {
                                    let actions = await SP.Data.WarehouseReasonsAndActions.getWarehouseActions();
                                    if (actions == null) {
                                        return;
                                    }
                                    
                                    for (let i = 0; i < actions.length; i++) {
                                        let action = actions[i];
                                        
                                        if (action.defaultAction) {
                                            shipmentLine.returnInfo.warehouseReturnActionId = action.id;
                                            break;
                                        }
                                    }

                                    let reasons = await SP.Data.WarehouseReasonsAndActions.getWarehouseReasons();
                                    if (reasons == null) {
                                        return;
                                    }

                                    for (let i = 0; i < reasons.length; i++) {
                                        let reason = reasons[i];
                                        if (reason.defaultReason) {
                                            shipmentLine.returnInfo.warehouseReturnReasonId = reason.id;
                                            break;
                                        }
                                    }

                                } catch {

                                }

                                this.AddShipmentLine(shipmentLine, 1);
                                return;
                            }
                        }
                    }
                }

                // Not found
                SP.Sounds.Error.play();
                SP.Sounds.Vibrate;
                SP.alertX("Item not found");
            }
        }


        async searchReturnShipments(barcode: string)
        {
            this.closeAllPages();
            this.hideScanLogo();

            StartLoading();
            try {

                let orderInfo = await SP.Data.ReturnShipment.getReturnShipmentInfo(barcode);
                if (orderInfo == null) {
                    SP.Sounds.Vibrate;
                    SP.Sounds.Error.play();

                    this.reset(false);
                    return;
                }

                this.currentOrder = orderInfo;
                await this.setCurrentCustomer(orderInfo.customerId);

                if (orderInfo.shipments.length == 1) {
                    this.currentShipmentId = orderInfo.shipments[0].shipmentId;
                    this.OpenStep2(orderInfo.shipments[0].shipmentId, orderInfo.shipments[0]);
                }
                else {
                    this.OpenStep1(orderInfo);
                }

                return;
            }
            finally {
                StopLoading();
            }

        }


        async onOpen() {
            this.reset(false);
            await this.getWarehouseReasonsAndActions();
            let shipmentId = SP.getHash("shipmentId");
            let orderId = SP.getHash("orderId");
            let refundId = SP.getHash("refundId");

            if (refundId) {
                await this.OpenStep3(refundId);
            }
            else if (shipmentId) {
                await this.OpenStep2(shipmentId, null);
            }
            else if (orderId) {
                console.log("Step 1")
                let data = await SP.Data.ReturnShipment.getReturnShipmentInfoByOrderId(parseInt(orderId));
                await this.OpenStep1(data);
            }
            else {
                await this.closeAllPages();
            }

            this.BindBarcodeListeners();
        }

        BindBarcodeListeners() {
            if (!this.bound) {
                barcodeListener.on(null, this.scan, this);
                barcodeListener.on("sp", this.finishReturn, this);
                barcodeListener.on("t", this.scanTote, this);
                this.bound = true;
            }
        }

        UnbindBarcodeListners() {
            if (this.bound) {
                barcodeListener.off(null, this.scan);
                barcodeListener.off("sp", this.finishReturn);
                barcodeListener.off("t", this.scanTote);
                this.bound = false;
            }
        }

        async onClose() {
            this.UnbindBarcodeListners();
            this.reset(false);
        }


        async closeAllPages() {
            this.step1_container.style.display = "none";
            this.step1_container.innerHTML = "";

            this.step2_container.style.display = "none";
            this.step2_container.innerHTML = "";

            this.step3_container.style.display = "none";
            this.step3_container.innerHTML = "";

            this.return_status.style.display = "none";
        }


        async OpenStep1(order: SP.ReturnOrderInfo) {
            ignoreHashChange = true;
            SP.setManyHash({ "orderId": order.orderId, "shipmentId": null });

            await this.closeAllPages();
            this.hideScanLogo();
            this.step1_container.innerHTML = "";
            this.step1_container.style.display = "block";
            this.currentStep = 1;

            try {
                // Set current customer
                await this.setCurrentCustomer(order.customerId);

                let orderInfo = new ReturnOrderInfo(order, this.currentCustomer);
                this.step1_container.appendChild(orderInfo.container);
            } catch {
                SP.alertX("Error! No customer found! try refresh");
                return;
            }
        }


        async OpenStep2(shipmentId: string, shipment: SP.ShipmentInfo) {
            ignoreHashChange = true;
            SP.setManyHash({ "orderId": null, "shipmentId": shipmentId });

            await this.closeAllPages();
            this.hideScanLogo();
            this.step2_container.innerHTML = "";
            this.step2_container.style.display = "block";
            this.return_status.style.display = "block";
            this.currentStep = 2;

            StartLoading();

            try {
                console.log("OpenStep2");
                console.log("shipment: " + shipment);

                if (shipment && shipment.lines.length > 0) {
                    console.log("Shipment not null");

                    if (!this.currentOrder) {
                        await this.setCurrentOrderInfo(shipment.order.orderId);
                    }

                    await this.loadDataStep2(shipment);
                    return;
                }

                console.log("Shipment is null");

                shipment = await SP.Data.ReturnShipment.getShipmentInfo(shipmentId);
                if (shipment == null) {
                    SP.Sounds.Vibrate;
                    SP.Sounds.Error.play();

                    SP.alertX("Shipment not found!");
                    this.reset(true);
                    return;
                }

                if (!this.currentOrder) {
                    await this.setCurrentOrderInfo(shipment.order.orderId);
                }

                await this.loadDataStep2(shipment);

            } finally {
                StopLoading();
            }
        }


        async OpenStep3(refundId: string) {
            ignoreHashChange = true;
            SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": refundId });

            this.closeAllPages();
            this.hideScanLogo();
            this.step3_container.innerHTML = "";
            this.step3_container.style.display = "block";
            this.currentStep = 3;

            StartLoading();

            try {
                var refund = await SP.Data.Refund.getRefundtInfo(refundId);
                if (!refund) {
                    SP.Sounds.Vibrate;
                    SP.Sounds.Error.play();

                    this.reset(true);
                    SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });
                    return;
                }

                // Set current customer
                await this.setCurrentCustomer(refund.order.customerId);

                if (this.currentCustomer.defaultReturnMethod === SP.ReturnMethod.ReceiveAndRefundAndConfirmExclGiftcard && refund.refundType == SP.RefundType.Gift_card) {
                    this.reset(true);
                    SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });
                    return;
                }

                if (refund.confirmed) {
                    this.reset(true);
                    SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });
                    return;
                }

                this.currentRefund = refund;

                let hasBundle = false;
                for (var i = 0; i < refund.lines.length; i++) {
                    let line = refund.lines[i];
                    if (line.orderLine.bundleParent != null) {
                        hasBundle = true;
                        break;
                    }
                }


                if (hasBundle) {
                    var refundBundleBalanceLines = await SP.Data.Refund.getRefundBundleBalance(refundId);
                    if (!refund) {
                        SP.Sounds.Vibrate;
                        SP.Sounds.Error.play();

                        this.reset(true);
                        return;
                    }

                    this.currentRefundBundleBalanceLines = refundBundleBalanceLines;
                }

                // Add Customer Info
                var customerInfo = new ReturnOrderCustomerInfo(refund.order);
                this.step3_container.appendChild(customerInfo.container);

                var refundInfo = new ReturnRefundInfo(refund, hasBundle);
                this.step3_container.appendChild(refundInfo.container);

                this.currentReturnRefundInfo = refundInfo;

                if (hasBundle) {
                    this.openBundleAssistant();
                }

            } finally {
                StopLoading();
            }
        }


        openBundleAssistant() {
            this.refundBundleAssistant.open((updatedRefundLines) => {
                let totalPrice = 0;

                this.currentReturnRefundInfo.updatedRefund.lines = updatedRefundLines;

                this.currentReturnRefundInfo.container.querySelectorAll(".returnRefund-item-container").forEach((element) => {
                    var findIndex = updatedRefundLines.findIndex((x) => x.refundLineId == element.getAttribute("data-refundlineid"));
                    if (findIndex >= 0) {
                        element.querySelector(".refundLinePrice").innerHTML = updatedRefundLines[findIndex].price.toString();

                        totalPrice += parseFloat(updatedRefundLines[findIndex].price.toString());
                    }
                    else {
                        totalPrice += parseFloat(element.querySelector(".refundLinePrice").innerHTML);
                    }
                });

                this.currentReturnRefundInfo.container.querySelector(".returnRefund-total").innerHTML = totalPrice.toString();
            }, this.currentRefund, this.currentReturnRefundInfo.updatedRefund.lines, this.currentRefundBundleBalanceLines);
        }


        async loadDataStep2(shipment: SP.ShipmentInfo) {

            if (shipment.shipmentState != SP.ShipmentState.ReturnPending) {
                this.reset(true);
                SP.setManyHash({ "orderId": null, "shipmentId": null, "refundId": null });
            }

            // Add Customer Info
            var customerInfo = new ReturnOrderCustomerInfo(shipment.order);
            this.step2_container.appendChild(customerInfo.container);

            // Add line info

            this.lines = {};
            this.currentShipmentId = shipment.shipmentId;
            console.log("loadDataStep2-ShipmentId: " + this.currentShipmentId);
            console.log(shipment);



            let expectedQty = 0;
            for (var i = 0; i < shipment.lines.length; i++) {
                let line = shipment.lines[i];
                this.AddShipmentLine(line, 0);
                expectedQty += line.qty;
            }

            this.return_pick_count.innerHTML = expectedQty.toString();
        }


        async AddShipmentLine(line: SP.ShipmentLineInfo, qty: number) {
            var lineInfo = new ReturnShipmentInfo(this.currentShipmentId, line, qty);
            this.lines[line.orderLine.id] = lineInfo;

            this.step2_container.appendChild(lineInfo.container);

            this.refreshReturnCount();
        }


        refreshReturnCount() {
            let quantity = 0;
            for (let key in this.lines) {
                let l = this.lines[key];
                quantity += l.updatedShipmentLine.quantity;
            }

            this.return_picked_count.innerHTML = quantity.toString();
        }

        async getWarehouseReasonsAndActions() {
            if (!this.warehouseReasons) this.warehouseReasons = await SP.Data.WarehouseReasonsAndActions.getWarehouseReasons(false);
            if (!this.warehouseActions) this.warehouseActions = await SP.Data.WarehouseReasonsAndActions.getWarehouseActions(false);
        }

        async setCurrentOrderInfo(orderId: number) {
            try {
                var orderInfo = await SP.Data.ReturnShipment.getReturnShipmentInfoByOrderId(orderId);
                if (!orderInfo) {
                    this.reset(true);
                    return;
                }

                this.currentOrder = orderInfo;

                // Set current customer
                await this.setCurrentCustomer(orderInfo.customerId);
            } catch {
                SP.alertX("Error! No customer found! try refresh");
            }
        }


        hideScanLogo() {
            this.scanLogo_container.style.display = "none";
        }

        // Set current customer
        async setCurrentCustomer(customerId: string) {
            try {
                var customer = await SP.Data.Customer.getCustomerInfo(customerId, false);
                if (!customer) {
                    this.reset(true);
                    return;
                }

                this.currentCustomer = customer;
            } catch {
                SP.alertX("Error! No customer found! try refresh");
            }
        }

        reset(fullReset: boolean) {
            if (fullReset) {
                SP.setHash("orderId", null);
                SP.setHash("shipmentId", null);
                SP.setHash("refundId", null);
            }

            this.closeAllPages();
            this.currentOrder = null;
            this.currentShipmentId = null;
            this.currentCustomer = null;
            this.currentRefund = null;
            this.lines = null;
            this.currentReturnRefundInfo = null;
            this.currentRefundBundleBalanceLines = [];
            this.currentStep = 1;

            this.return_picked_count.innerText = "0";
            this.return_pick_count.innerText = "0";

            this.scanLogo_container.style.display = "block";

        }
    }

    RegisterApp(appId, App_Return);
}